<template>
  <b-form-group :id="id" :label-for="id" :label="label" class="user-input">
    <b-form-input
      :id="inputId"
      :value="model"
      :placeholder="placeholder"
      :required="required"
    ></b-form-input>
  </b-form-group>
</template>
<script>
export default {
  props: {
    id: {
      type: String
    },
    inputId: {
      type: String
    },
    model: {
      type: String
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style scoped>
.user-input {
  text-align: left;
}
</style>
